import { Response } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Product } from '../_models/product';

import 'rxjs/Rx';

import { AuthenticationService } from './auth/authentication.service';
import { environment } from '../../environments/environment';
import { ApplicationNotificationService } from './application-notification.service';

@Injectable()
export class QueryService {
  public token: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthenticationService,
    private applicationNotificationService: ApplicationNotificationService,
    ) {
  }

  searchProducts(searchTerm: string, displayedInHQ: boolean = false): Observable<{} | Product[]> {
    this.authService.checkTokenRefresh();
    let query_url = '/products/?q=' + searchTerm;
    if (displayedInHQ) {query_url += '&all=1'}
    return this.getQuery(query_url)
      .map(response => response as Product[])
      .catch(this.handleError.bind(this));
  }

  getProduct(product_id: number): Observable<any> {
    let url = '/products/' + product_id + '/';
    return this.getQuery(url);
  }

  getAuthHeaders(): any {
    const token = 'JWT ' + this.authService.token;
    return new HttpHeaders().set('Authorization', token);
  }

  getQuery(url: string): Observable<any> {
    this.authService.checkTokenRefresh();
    let query_url = environment.API + url;
    let myHeaders = this.getAuthHeaders();
    const token = 'JWT ' + this.authService.token;
    return this.http.get(query_url, {
      headers: myHeaders
    })
      .catch(this.handleError.bind(this));
  }

  putQuery(url: string, body: string = ''): Observable<any> {
    this.authService.checkTokenRefresh();
    let query_url = environment.API + url;
    return this.http.put(query_url, body, { headers: this.getAuthHeaders()})
      .catch(this.handleError.bind(this));
  }

  deleteQuery(url:string): Observable<any> {
    this.authService.checkTokenRefresh();
    let query_url = environment.API + url;
    return this.http.delete(query_url, { headers: this.getAuthHeaders()});
  }

  patchQuery(url: string, body: string = ''): Observable<any> {
    this.authService.checkTokenRefresh();
    let myHeader = this.getAuthHeaders().set('Content-Type','application/json');
    let query_url = environment.API + url;
    return this.http.patch(query_url, body, { headers: myHeader })
      .catch(this.handleError.bind(this));
  }

  patchQueryFormData(url: string, payload:FormData): Observable<any> {
    this.authService.checkTokenRefresh();
    let query_url = environment.API + url;
    let myHeader = this.getAuthHeaders().delete('content-type');
    return this.http.patch(query_url, payload, { headers: myHeader })
      .catch(this.handleError.bind(this));
  }

  postQuery(url: string, payload: string): Observable<any> {
    this.authService.checkTokenRefresh();
    let query_url = environment.API + url;
    let myHeader = this.getAuthHeaders().set('Content-Type','application/json');
    return this.http.post(query_url, payload, { headers: myHeader })
      .catch(this.handleError.bind(this));
  }


  postQueryFormData(url: string, payload:FormData): Observable<any> {
    this.authService.checkTokenRefresh();
    let query_url = environment.API + url;
    let myHeader = this.getAuthHeaders().delete('content-type');
    return this.http.post(query_url, payload, { headers: myHeader })
      .catch(this.handleError.bind(this));
  }


  private handleError(error: any): Observable<any> {
    // If we are developing
    let code = error.status;
    let title = code + '-error';
    if (code === 401 || code === 403) {
      this.applicationNotificationService.addGrowl('Authentication required when trying to visit, ' + error.url);
      this.authService.logout();
    } else {
      this.applicationNotificationService.addGrowl(
        'Error when visiting ' + error.url + ' . Status text: ' + error.statusText);
    }
    console.error('API error gecatcht.', error);
    return Observable.throw(error.message);
  }
}




// WEBPACK FOOTER //
// /app/src/app/shared/query.service.ts